module.exports = __webpack_public_path__ + "static/media/exc_she_pil.8f8afc09.png";